import { RouteObject } from "react-router";
import AppExtensionProviderRegistry, { AppExtension, AppExtensionProvider } from "../../framework/app/app.extension.provider";
import CakeMenu from "./cake.custom.menu";
import CakeWelcomePage from "./welcome/cake.welcome.page";

export const PRODUCT = "cake";

export class CakeAppExtensionProvider implements AppExtensionProvider {
    
    constructor() { 
      AppExtensionProviderRegistry.registerProvider(
        PRODUCT,
        this
      );
    }
    
    getAppExtension(): AppExtension {
      return {
        onAppInit: () => {
          
        },
        getAppImage: () => {
            return `./products/${PRODUCT}/banner.png`
        },
        getAppBar: () => {
          return null;
        },
        getMenu: () => {
          return CakeMenu;
        },
        getRoutes: ():RouteObject[] => {
            const welcome:RouteObject = {
                path: "/welcome",
                element: CakeWelcomePage
            }
            return [welcome];
        },
        getDefaultRoute: () => {
            return `/welcome`;
        },
        getWelcomePage() {
            return CakeWelcomePage;
        },
      };
    }
  }